import { useEffect, useState, useContext } from 'react';
import { Button, Grid, Message, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import Loading from '../../../components/Loading';
import History from './History';
import UpdatePaymentInfo from './UpdatePaymentInfo';
import { getAPI, deleteAPI } from '../../../libs/fetchAPI';
import AppContext from '../../../context/HeaderContext';
import Confirm from '../../../components/Confirm';

const Container = styled.div`
	margin-top: 10px;
	width : 900px;
`;

const GridContainer = styled.div`
	margin-top: 40px;
`;

// Ability to select a plan/subscription

// Show current plan/subscription
// Show payment history
// Show current number of users
// Show # of test runs MTD
// Show estimated amount for next bill

function Billing() {
	const { current_organization_id }                            = useContext(AppContext);
	const [ loading, setLoading ]                                = useState(true);
	const [ saving ]                                             = useState(false);
	const [ deleting, setDeleting ]                              = useState(false);
	const [ errors ]                                             = useState([]);
	const [ refresh, setRefresh ]                                = useState(false);
	const [ show_history ]                                       = useState(false);
	const [ show_update_payment_info, setShowUpdatePaymentInfo ] = useState(false);
	const [ active_user_count, setActiveUserCount ]              = useState(0);
	const [ rate_per_user, setRatePerUser ]                      = useState(0);
	const [ next_bill_estimate, setNextBillEstimate ]            = useState(0);
	const [ next_payment_date, setNextPaymentDate ]              = useState(0);
	const [ stripe_info, setStripeInfo ]                         = useState({});
	const [ show_confirm, setShowConfirm ]                       = useState(false);
	const [ canceled_message, setCanceledMessage ]               = useState(false);

	/* eslint-disable */
	useEffect(() => {
		setLoading(true);
		const params = new URLSearchParams({
			organization_id : current_organization_id,
		});

		Promise.all([
			getAPI(`/users?${params}`),
			getAPI(`/next_payment?${params}`),
			getAPI(`/stripe_information?${params}`)
		]).then(data => {
			const [ users, next_payment, stripe_info ] = data;
			const user_count = users.data.filter(user => Number(user.active) === 1).length;

			setActiveUserCount(user_count);

			const rate = getRatePerUser(active_user_count);
			setRatePerUser(rate);
			setNextBillEstimate(parseFloat(rate) * user_count);

			setNextPaymentDate(next_payment.data[0].next_payment_date);
			setStripeInfo(stripe_info.data[0]);

			setLoading(false);
			setRefresh(false);
		});
	}, [refresh]);
	/* eslint-enable */

	const handleClosePaymentInfo = () => {
		setShowUpdatePaymentInfo(false);
		setRefresh(true);
	}

	const handleNo = () => {
		setShowConfirm(false);
	}

	const handleCancelMembership = () => {
		setDeleting(true);

		deleteAPI(`/subscriptions`).then(() => {
			setDeleting(false);
			setShowConfirm(false);

			// Show a message
			setCanceledMessage(true);
		});

	}

	if(loading) {
		return <Loading />
	}

	if(!stripe_info) {
		return <div>Billing needs to manually be added for the organization</div>
	}

	return (
		<>
			<History
				open={show_history}
			/>

			<UpdatePaymentInfo
				open={show_update_payment_info}
				saving={saving}
				errors={errors}
				handleClose={handleClosePaymentInfo}
			/>

			<Confirm
				open={show_confirm}
				handleYes={handleCancelMembership}
				handleNo={handleNo}
				loading={deleting}
				header_content="Cancel Membership"
				body_content="Are you sure you want to cancel your membership? Your membership will be canceled immediately and you will no longer be able to upload test result data. If you decide to reactivate your membership your data will still be here waiting for you."
			/>

			<Modal
				open={canceled_message}
				closeIcon
				onClose={() => setCanceledMessage(false)}
			>
				<Modal.Content>
					<p>Your membership has been canceled.</p>
				</Modal.Content>
			</Modal>

			<Container>
				<Message info>
					There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
				</Message>
				<GridContainer>
					<Grid divided="vertically">
						<Grid.Row columns={2}>
							<Grid.Column>
								<p>
									<span>{active_user_count} {active_user_count > 1 ? `users` : `user`}</span>
									<span> @ {rate_per_user}/month per user</span>
								</p>
								<p>
									<span>332,002 tests ran @ $0.00/month</span>
								</p>
							</Grid.Column>
							<Grid.Column>
								Bill estimate: ${next_bill_estimate}
							</Grid.Column>
						</Grid.Row>

						<Grid.Row columns={2}>
							<Grid.Column>
								<p>
									<span>{stripe_info.card_brand.charAt(0).toUpperCase() + stripe_info.card_brand.slice(1)}</span>
									<span>  ** {stripe_info.last_four}</span>
								</p>

								<p>
									{stripe_info.name_on_card}
								</p>

								<p>Expires: {stripe_info.exp_month}/{stripe_info.exp_year}</p>
							</Grid.Column>
							<Grid.Column>
								<Button primary onClick={() => setShowUpdatePaymentInfo(true)}>
									Update payment info
								</Button>
							</Grid.Column>
						</Grid.Row>

						<Grid.Row columns={2}>
							<Grid.Column>Next charge: {next_payment_date}</Grid.Column>
							<Grid.Column>
								<Button primary>
									View payment history
								</Button>
							</Grid.Column>
						</Grid.Row>

						<Grid.Row columns={2}>
							<Grid.Column></Grid.Column>
							<Grid.Column>
								<Button negative onClick={() => setShowConfirm(true)}>
									Cancel Membership
								</Button>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</GridContainer>
			</Container>
		</>
	);
}

function getRatePerUser(count) {
	if(count < 5) {
		return `29.99`;
	}
	else if(count < 20) {
		return `26.99`;
	}
	else {
		return `25.99`;
	}
}

export default Billing;
